# Create VueX store and initialize cart
import Vue from 'vue'
import Vuex from 'vuex'
import * as cart from 'library/store/cart'
import * as layout from 'library/store/layout'
import * as globals from 'library/store/globals'
import * as customer from 'library/store/customer'
import * as customerNavigation from 'library/store/customer/navigation'
import * as favorites from 'library/store/favorites'
import * as bundles from 'library/store/bundles'

# Services / Plugins
import { addGtmCartSubscribers } from 'library/services/gtm/cart-events'
import { addValidateCartItemsSubscribers } from 'library/services/validate-cart-items'
import { applyAutomaticCartItems } from 'library/services/automatic-cart-items'
import { lazyHydrateCart } from 'library/services/hydrate-cart'
import { hydrateProductFavorites } from 'library/services/product-favoriting'
import { hydrateCustomer } from 'library/services/hydrate-customer'
import { handleExpertVoiceReferral } from 'library/services/expert-voice/handle-referral-plugin'
import { sync } from 'vuex-router-sync'
import { syncBundlesToCartAttributes } from 'library/services/shopify/bundling/sync-cart-attribute'

# Init Vuex
Vue.use Vuex
store = new Vuex.Store modules:
	cart: { ...cart, namespaced: true }
	layout: { ...layout, namespaced: true }
	globals: { ...globals, namespaced: true }
	customer: {
		...customer,
		namespaced: true
		modules:
			navigation: { ...customerNavigation, namespaced: true }
	}
	favorites: { ...favorites, namespaced: true }
	bundles: { ...bundles, namespaced: true }

	# Allows the footer to react to the secondary-content rendering
	pdp:
		namespaced: true
		state: ->
			secondaryContentRendered: false
			breadcrumbs: null
		mutations:
			secondaryContentRendered: (state) ->
				state.secondaryContentRendered = true
			setBreadcrumbs: (state, breadcrumbs) ->
				state.breadcrumbs = breadcrumbs

# Add helpers
import $craft from './craft'
store.$craft = $craft

# Hydrate global data
store.dispatch 'globals/fetch'
store.dispatch 'bundles/fetch'
layout.createListeners store

# Plugins with a dependency on vuex
applyAutomaticCartItems store
addGtmCartSubscribers store
addValidateCartItemsSubscribers store
lazyHydrateCart store
hydrateProductFavorites store
hydrateCustomer store
syncBundlesToCartAttributes store

# Boot up vue-router-sync and boot vue-router globally
import VueRouter from 'vue-router'
Vue.use VueRouter
router = new VueRouter
	routes: [] # Silence warning
	mode: 'history'
sync store, router

# Plugins with an additional dependency on router
router.onReady ->
	handleExpertVoiceReferral { store, router }

# Expose for theme.js to use
window.$store = store
window.$router = router
